import { VenueSurchargesType } from '@api';
import { z } from 'zod';

const venueSurchargesFormSchema = z.object({
  facilityFee: z.number().nullable(),
  publicTransportFee: z.number().nullable(),
  notes: z.string(),
});

type VenueSurchargesFormSchemaType = typeof venueSurchargesFormSchema;
export type VenueSurchargesFormDataType =
  z.infer<VenueSurchargesFormSchemaType>;

type UseVenueSurchargesFormSchemaReturnType = {
  schema: VenueSurchargesFormSchemaType;
  defaultValues: VenueSurchargesFormDataType;
};

export const useVenueSurchargesFormSchema = (
  venueSurcharges: VenueSurchargesType
): UseVenueSurchargesFormSchemaReturnType => {
  const defaultValues: VenueSurchargesFormDataType = {
    facilityFee: venueSurcharges.facilityFee
      ? venueSurcharges.facilityFee.value
      : null,
    publicTransportFee: venueSurcharges.publicTransportFee
      ? venueSurcharges.publicTransportFee.value
      : null,
    notes: venueSurcharges.notes ?? '',
  };

  return { schema: venueSurchargesFormSchema, defaultValues };
};
